// extracted by mini-css-extract-plugin
module.exports = {"answerItem":"AnswerItem_answerItem__3q6Z-","success":"AnswerItem_success__OJ7g3","error":"AnswerItem_error__3uBIb"};